import React from 'react';

import { Box } from '@mui/material';

import { SCOUT_BLUE } from '../../../../ThemeContext/constants';
import MultiSelect from '../../CustomUIElements/MultiSelect';

import type { AutocompleteInputChangeReason } from '@mui/material/Autocomplete';
import type { UIEventHandler } from 'react';

import type { IOptionType } from '../../CustomUIElements/MultiSelect';

const filterSelectGroupStyle = {
  fontFamily: 'Source Sans Pro',
  fontSize: '14px',
  fontWeight: 'bold',
  color: SCOUT_BLUE
};

const filterSelectSubLabelStyle = {
  fontSize: '12px',
  fontWeight: '400'
};

const MultiSelectFilter = ({
  handleFilterChange,
  selectOptions,
  name,
  label,
  subLabel,
  value,
  freeInput = false,
  disabled = false,
  displayLabel = false,
  onInputChange,
  onListboxScroll
}: {
  handleFilterChange: (name: string, value: IOptionType[]) => void;
  selectOptions: IOptionType[];
  name: string;
  label: string;
  subLabel?: string;
  value: IOptionType[];
  freeInput?: boolean;
  disabled?: boolean;
  displayLabel?: boolean;
  onInputChange?: (value: string, reason: AutocompleteInputChangeReason) => void;
  onListboxScroll?: UIEventHandler<HTMLUListElement>;
}) => (
  <Box id={`${name}-filter`} sx={filterSelectGroupStyle}>
    {label}
    {subLabel ? <Box sx={filterSelectSubLabelStyle}>{subLabel}</Box> : null}
    <MultiSelect
      disabled={disabled}
      displayLabel={displayLabel}
      filters={value}
      freeInput={freeInput}
      name={name}
      onInputChange={onInputChange}
      onListboxScroll={onListboxScroll}
      selectOptions={selectOptions}
      handleFilterChange={(filterName, filterValue) =>
        handleFilterChange(filterName, filterValue as IOptionType[])
      }
    />
  </Box>
);

export default MultiSelectFilter;
